// extracted by mini-css-extract-plugin
export default {"mbactH4":"MbactH4_mbactH4__4lgp+"};